import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useInView } from 'framer-motion';

interface SkillProgressProps {
  name: string;
  level: number;
  icon: string;
  description: string;
  delay?: number;
}

const SkillProgress: React.FC<SkillProgressProps> = ({
  name,
  level,
  icon,
  description,
  delay = 0,
}) => {
  const { t } = useTranslation('skills');

  const ref = useRef(null);
  const isVisible = useInView(ref, { once: true, amount: 0.1 });

  useEffect(() => {
    if (isVisible) {
      // setAnimatedLevel(level);
    }
  }, [isVisible, level]);

  return (
    <motion.div
      ref={ref}
      className="relative p-6"
    >
      {/* Skill Header */}
      <div className="flex flex-col items-center text-center space-y-3 mb-0">
        <motion.div
          initial={{ scale: 0 }}
          animate={isVisible ? { scale: 1 } : {}}
          transition={{ duration: 0.8 }}
          className="w-12 h-12 bg-gradient-to-r from-primary-500 to-secondary-500 rounded-full flex items-center justify-center text-xl shadow-lg"
        >
          {icon}
        </motion.div>
        <h3 className="text-xl font-display font-bold gradient-text">{name}</h3>
        <p className="text-dark-300 text-sm max-w-xs">{t(`descriptions.${name}`, description)}</p>
      </div>



      <div className="mt-4"></div>
    </motion.div>
  );
};

export default SkillProgress;